import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="nav">
      <div className="container">
        <div className="nav-top">
          <div className="nav-contact">
            <a href="tel:+1234567890" className="nav-contact-link">CALL US: +1 234-567-890</a>
            <a href="mailto:hello@savoryhaven.com" className="nav-contact-link">hello@savoryhaven.com</a>
          </div>
          <div className="nav-social">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">Instagram</a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">Facebook</a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">LinkedIn</a>
          </div>
        </div>
        <div className="nav-content">
          <Link to="/" className="nav-logo">SAVORY HAVEN</Link>
          <ul className="nav-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/join" className="nav-cta">Join as Partner</Link></li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
